import { IPayrollSettings } from "@wingspanhq/payments/dist/interfaces";
import { TaxYear } from "../../../shared/constants/taxYear";
import { selectorTypeFormLabel } from "./selectorTypeFormLabel";

export const selectorCurrentYearTaxFormTypeLabel = (
  settings: IPayrollSettings,
  year: TaxYear
) => {
  const filingSettings =
    settings.calculationSettings1099?.filingSettings?.[year];

  const taxFormType = filingSettings?.taxFormType;

  return selectorTypeFormLabel(taxFormType) || "1099";
};
